import axios from "axios";

export const axiosApiInstance = axios.create({
  baseURL: import.meta.env.VITE_API_ENDPOINT,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosApiInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);
